import { makeStyles } from "@material-ui/core";

const useSignableDocumentsEditorStyles = makeStyles((theme) => ({
  editorContainer: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  headerLabel: {
    fontWeight: 500,
    marginRight: theme.spacing(1),
  },
  textarea: {
    width: "100%",
    minHeight: 200,
    padding: theme.spacing(2),
    fontSize: "14px",
    fontFamily: "inherit",
    lineHeight: 1.6,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    resize: "vertical",
    "&:focus": {
      outline: "none",
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.light}`,
    },
  },
  errorText: {
    color: "#C4455B",
    fontSize: "0.75rem",
    marginTop: theme.spacing(0.5),
  },
  editorWrapper: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    overflow: "hidden",
  },
  tabsContainer: {
    backgroundColor: theme.palette.background.default,
  },
  previewContainer: {
    padding: theme.spacing(2),
    minHeight: 200,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    marginTop: theme.spacing(1),
    overflow: "auto",
  },
  htmlPreview: {
    width: "100%",
    height: "100%",
    minHeight: 200,
  },
  chip: {
    height: 20,
    fontSize: "0.75rem",
  },
   "@global": {
    ".ace_autocomplete": {
      width: "500px !important",
    },
  },
}));

export default useSignableDocumentsEditorStyles;